import { usePetitionDetailsPageFcm } from 'src/app/pages/petitionGamma/details/pageContext';

export function useShowNewlyCreatedPetitions(): boolean {
	const { newlyCreatedPetitionsEnabled } = usePetitionDetailsPageFcm();

	return newlyCreatedPetitionsEnabled;
}
